import React from 'react'
import { Form, Select, Divider, Card} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect } from 'react';
import SelectTypes from '../../select/SelectTypes';

const { Option } = Select;

export function RegistrationFormInfo({currentRegistrationType, 
    setCurrentRegistrationType,
    setSomethingChanged,
    isSl,
    getRentCost,
    record,
    form
}) {

    useEffect(() => {
        form.setFieldsValue({
            sleep:record?.registrations[0]?.sleep,
            notes: record?.registrations[0]?.notes,
            characterId: record?.registrations[0]?.character?.id
        }) 
    }, // eslint-disable-next-line
    [])

    function characterChanged() {
        setSomethingChanged(true)
    }
    return (
        <Card>
            <Form.Item
                label="Register as"
                name="registrationType"
            >
                <Select 
                    name="registrationType" 
                    defaultValue={currentRegistrationType}
                    onChange={(value) => {
                        setCurrentRegistrationType(value);
                        setSomethingChanged(true)}
                    }
                >
                    <Option 
                        value={1} 
                        key={1}
                        disabled={isSl}
                    >
                        Player
                    </Option>

                    <Option 
                        value={2} 
                        key={2}
                        disabled={isSl}
                    >
                        NPC
                    </Option>

                    <Option 
                        value={3} 
                        key={3}
                        disabled={!isSl}
                    >
                        SL
                    </Option>
                </Select>
            </Form.Item>

            <Divider />
            <h3>The next items are optional and can be changed/filled in later</h3>
            {/* {record.story !== "Stormvloed" && <Form.Item
                label="Sleep"
                name="sleep"
            >
            <Select 
                    name="sleep" 
                    onChange={() => setSomethingChanged(true)}
                >
                    <Option 
                        value={"tent"} 
                        key={1}
                    >
                        Tent
                    </Option>

                    <Option 
                        value={"inside"} 
                        key={2}
                    >
                        Inside (maximum of 20 spots)
                    </Option>

                    <Option 
                        value={"doesNotApply"} 
                        key={3}
                    >
                        Does not apply
                    </Option>

                    <Option 
                        value={"other"} 
                        key={4}
                    >
                        Other (please specify in the notes)
                    </Option>

                    <Option 
                        value={"unknown"} 
                        key={5}
                    >
                        Unknown
                    </Option>

                </Select>
            </Form.Item>} */}



            {currentRegistrationType === 1 &&
            <>
            
            <Form.Item
                label="Rent a weapon"
                name="hire"
            >
            <Select 
                    name="hire" 
                    allowClear
                    onChange={() => setSomethingChanged(true)}
                >
                    <Option 
                        value={"dagger"} 
                        key={1}
                    >
                        Dagger (+ €{getRentCost(record?.story)})
                    </Option>

                    <Option 
                        value={"sword"} 
                        key={2}
                    >
                        Sword (+ €{getRentCost(record?.story)})
                    </Option>
                </Select>
            </Form.Item>
            </>}

            <Form.Item
                label="Notes"
                name="notes"
            >
                    <TextArea 
                        onChange={() => setSomethingChanged(true)} 
                        name="notes" 
                        rows={8}
                    />
            </Form.Item>

            {currentRegistrationType === 1 &&
                <>
                    <Divider />
                    <SelectTypes 
                        name={"characterId"}
                        label={"Character"}
                        url={`/api/character/myEvent`}
                        allowClear={true}
                        //mode="multiple"
                        hasChanged={characterChanged}
                    />
                </>
            }
        </Card>
    )
}